import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { isPast } from 'date-fns'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import StartEndDateRangeFields from '../../../../../ReusableFormFields/StartEndDateRangeFields'

import { rightSelector } from '../../../../../../modules/selectors/rights'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

const DatesFields = ({ formik }) => {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const right = useSelector(rightSelector)

  const { start_date: rightStartDate, end_date: rightEndDate } = right

  const isRightStartDateInThePast = useMemo(() => isPast(new Date(rightStartDate)), [rightStartDate])

  const minStartDate = useMemo(
    () => (isRightStartDateInThePast ? new Date() : rightStartDate),
    [isRightStartDateInThePast, rightStartDate]
  )

  return (
    <div className={drawerFormClasses.subSection}>
      <FieldLabelWrapper label={t('Start and end dates')}>
        <p>
          {t(
            `Please enter the start and end date for this ad set. You can select any dates within the agreed period from ${rightStartDate} to ${rightEndDate}.`
          )}
        </p>
        <StartEndDateRangeFields formik={formik} minDate={minStartDate} maxDate={rightEndDate} />
      </FieldLabelWrapper>
    </div>
  )
}

export default DatesFields
